var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEnV3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "519.37 420.88 984.09711 359.54666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#505971;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.83,
    y1: 8259.98,
    x2: 323.46,
    y2: 8082.72,
    gradientTransform: "matrix(1, 0, 0, -1, 539, 8734.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f098c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ea8cb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#dd70a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d05599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c5579b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a15ea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9362a4"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 767.02364,780.42665 c -98.42051,0 -177.87043,-80.25893 -177.87043,-177.97385 a 134.04763,134.17103 0 0 1 0.7111,-16.889 c -16.17442,-7.03306 -37.9653,-17.58869 -50.6204,-27.43256 -14.76428,-10.55562 -21.09183,-23.22237 -19.68169,-35.88912 2.10919,-13.36644 12.6551,-21.81094 21.79088,-25.3335 l 149.73995,-55.58893 a 173.95337,174.11351 0 0 1 75.93059,-16.889 c 98.42051,0 177.85837,80.22274 177.85837,178.02211 0,97.79936 -80.14896,177.97385 -177.85837,177.97385 z M 573.68989,530.63836 a 433.38289,433.78186 0 0 0 47.10107,22.51063 l 16.17442,6.33337 -3.51932,16.889 c -1.41014,8.4445 -2.80823,17.58869 -2.80823,26.03318 a 135.68676,135.81168 0 1 0 135.67471,-135.79961 132.04691,132.16848 0 0 0 -59.05713,13.36644 l -2.10918,0.69969 z m -18.27155,6.33338 z",
    id: "path21",
    style: {
      fill: "url(#linear-gradient)",
      strokeWidth: 1.2058
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1122.1649,574.67245 c 0,7.91847 -7.3271,14.34266 -16.1313,14.34266 -8.3041,0 -15.6428,-6.42419 -16.1313,-14.34266 v -44.00458 c 0,-13.84849 -8.3041,-21.27279 -17.5967,-21.27279 -9.7813,0 -18.0854,6.43596 -18.0854,21.76696 v 43.53394 c 0,7.91847 -7.3388,14.34266 -16.1313,14.34266 -8.3157,0 -15.643,-6.42419 -16.1315,-14.34266 v -45.01644 c 0,-13.35433 -8.3155,-20.77863 -17.5966,-20.77863 -9.78117,0 -18.60863,5.44762 -18.60863,21.76696 v 43.53394 c 0,7.91847 -7.32714,14.34267 -16.13133,14.34267 -8.30411,0 -15.64288,-6.4242 -16.13135,-14.34267 V 493.5699 c 0,-7.9067 7.33876,-14.34266 16.13135,-14.34266 8.79257,0 16.13133,6.43596 16.13133,14.34266 v 2.47085 c 4.8964,-11.36589 16.61983,-17.80185 27.91303,-17.80185 16.6198,0 27.913,5.44762 35.2051,20.28446 a 34.449191,34.850679 0 0 1 30.8205,-20.28446 c 25.4123,0 41.5436,16.31934 41.5436,48.95803 v 47.47552 z",
    id: "path23",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1138.7847,534.12706 c 0,-33.62702 24.9356,-55.39399 55.7328,-55.39399 30.7973,0 56.2213,21.76697 56.2213,55.39399 0,33.62702 -24.9355,56.3235 -56.2213,56.3235 -30.7972,-0.44711 -55.7328,-22.69648 -55.7328,-56.3235 z m 80.18,0 c 0,-14.34267 -10.7581,-24.23781 -23.9587,-24.23781 -13.2003,0 -23.9588,9.89514 -23.9588,24.23781 0,14.83683 10.7585,25.22615 23.9588,25.22615 a 24.865754,25.155554 0 0 0 23.9587,-25.22615 z",
    id: "path25",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1263.4508,534.12706 c 0,-33.62702 24.9356,-55.39399 55.7328,-55.39399 30.7974,0 56.2211,21.76697 56.2211,55.39399 0,33.62702 -24.9469,56.3235 -56.2327,56.3235 -31.2973,-0.44711 -55.7212,-22.69648 -55.7212,-56.3235 z m 79.6913,0 c 0,-14.34267 -10.758,-24.23781 -23.9585,-24.23781 -13.2004,0 -23.9587,9.89514 -23.9587,24.23781 0,14.83683 10.7583,25.22615 23.9587,25.22615 a 24.540104,24.826108 0 0 0 23.9469,-25.22615 z",
    id: "path27",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1471.2043,435.22267 c 0,-7.91847 7.3273,-14.34267 16.1313,-14.34267 8.8041,0 16.1315,6.4242 16.1315,14.34267 v 139.93218 c 0,7.9067 -7.339,14.3309 -16.1315,14.3309 -8.3158,0 -15.6427,-6.4242 -16.1313,-14.3309 v -1.98844 c -6.8503,11.40118 -20.0391,17.28415 -31.7743,17.28415 -26.8894,0 -51.8247,-20.2727 -51.8247,-55.8764 0,-35.6037 24.4237,-55.88816 51.8247,-55.88816 6.8388,0 22.9701,2.97678 31.7743,17.30768 z m -25.424,126.10721 c 14.1774,0 25.9126,-12.86016 25.9126,-27.20282 0,-14.34267 -11.6886,-27.21459 -25.9126,-27.21459 -16.1313,0 -24.924,12.86016 -24.924,27.20282 -0.4883,14.35443 8.7927,27.21459 24.924,27.21459 z",
    id: "path29",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1001.4299,656.33975 c 20.0392,0 38.1244,14.83684 38.1244,41.53373 0,26.69689 -18.0852,41.54549 -38.1244,41.54549 -8.80417,0 -18.60859,-4.44752 -23.47008,-12.86016 v 39.56882 c 0,5.88296 -5.37323,10.37755 -11.73507,10.37755 -6.36181,0 -11.73504,-4.44752 -11.73504,-10.37755 v -98.48082 c 0,-5.88296 5.38486,-10.37755 11.73504,-10.37755 6.3502,0 11.73507,4.94169 11.73507,10.37755 v 1.49427 c 6.83865,-10.88348 18.57372,-12.80133 23.47008,-12.80133 z m -4.40789,21.17867 c -10.74648,0 -19.06219,9.41275 -19.06219,20.2727 0,10.38931 8.31571,20.28446 19.06219,20.28446 11.73509,0 18.60859,-9.41275 18.60859,-20.28446 0,-10.87172 -6.8852,-20.2727 -18.60859,-20.2727 z",
    id: "path31",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1064.9666,614.24126 c 7.8275,0 14.1891,5.88297 14.1891,13.8485 0,7.96553 -6.3616,13.8485 -14.1891,13.8485 -7.827,0 -14.6542,-5.88297 -14.6542,-13.8485 0,-7.96553 6.8386,-13.8485 14.6542,-13.8485 z m 11.7353,113.74123 c 0,5.94179 -5.3733,10.38931 -11.7353,10.38931 -6.3618,0 -11.7233,-4.94169 -11.7233,-10.38931 v -60.33568 c 0,-5.88296 5.3732,-10.37755 11.7233,-10.37755 6.3502,0 11.7353,4.44752 11.7353,10.37755 z",
    id: "path33",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1118.2571,727.98249 c 0,5.94179 -5.3734,10.38931 -11.735,10.38931 -6.3618,0 -11.7234,-4.94169 -11.7234,-10.38931 V 624.13641 c 0,-5.88297 5.3732,-10.38932 11.7234,-10.38932 6.3501,0 11.735,4.44752 11.735,10.38932 z",
    id: "path35",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1132.4345,697.32048 c 0,-25.21438 18.0854,-41.03956 41.067,-41.03956 22.9815,0 41.0553,15.82518 41.0553,41.03956 0,25.21438 -18.6087,41.54549 -41.0553,41.54549 -22.4467,0 -41.067,-16.31934 -41.067,-41.54549 z m 58.6637,0 c 0,-10.87172 -7.8273,-18.29602 -17.5967,-18.29602 a 17.63166,17.837147 0 0 0 -17.5968,18.29602 c 0,10.88348 7.8156,18.82548 17.5968,18.82548 9.281,-0.0235 17.5967,-7.942 17.5967,-18.82548 z",
    id: "path37",
    style: {
      strokeWidth: 1.1698
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1233.6304,657.76343 v -20.76686 c 0,-5.88297 5.3732,-10.38932 11.7235,-10.38932 6.3502,0 11.7351,4.44752 11.7351,10.38932 v 20.76686 h 8.8043 c 4.8846,0 8.3039,4.44752 8.3039,9.41274 0,4.96522 -3.9078,9.41274 -8.3039,9.41274 h -8.8043 v 51.42888 c 0,5.94179 -5.3733,10.38931 -11.7351,10.38931 -6.3618,0 -11.7235,-4.94169 -11.7235,-10.38931 v -51.46417 h -6.3617 c -4.8849,0 -8.304,-4.44752 -8.304,-9.41275 0,-4.96522 3.9076,-9.41274 8.304,-9.41274 z",
    id: "path39",
    style: {
      strokeWidth: 1.1698
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnV3);
export default __webpack_public_path__ + "static/media/logo-en-v3.80e1dbe0cbdf97f02c943318c66de60e.svg";
export { ForwardRef as ReactComponent };